import { Link } from "react-router-dom";
import { FileText } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Maintenance, PricingGrid } from "../components/Pricing";
import { SectionLabel } from "../components/Motion";
import { CtaBand } from "../components/CtaBand";
import { useLang } from "../i18n/LangContext";

export default function Services() {
  const { t, path } = useLang();
  return (
    <>
      <PageHero testid="services-hero" label={t.pricing.label} lines={t.pricing.title} accentLine={2} sub={t.pricing.preview}>
        <Link to={path("sheet")} data-testid="open-pricing-sheet-link"
          className="label mt-10 inline-flex items-center gap-3 text-lav hover:text-ivory">
          <FileText className="h-4 w-4" />{t.sheet.title} — PDF
        </Link>
      </PageHero>
      <section className="bg-ivory py-24 text-ink md:py-32" data-testid="services-packages">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10">
          <SectionLabel tone="text-ink/60">{t.pricing.label}</SectionLabel>
          <div className="mt-14"><PricingGrid /></div>
        </div>
      </section>
      <section className="mx-auto max-w-[1440px] px-5 py-24 md:px-10 md:py-32">
        <Maintenance />
      </section>
      <CtaBand />
    </>
  );
}
